import type { GlyphKind } from '@common/components/kind-glyphs/send-kind';
import { nameOrFormattedPhone } from '@common/utils/phone-validation-utils';
import type { CalendarLeanEvent } from '../types';

/**
 * The words that name where an occurrence goes — "To: …" on the hover card and
 * in the delete confirmation. One function, because the two had drifted: the
 * hover card named a WhatsApp Status in the reader's language while the delete
 * dialog printed whatever English name was stored at compose time, so the same
 * chip was "My Status" in one place and a raw stored label in the other.
 *
 * `myStatusLabel` is passed in already translated, so this stays pure.
 */
export function destinationName(
    event: Pick<CalendarLeanEvent, 'audienceGroupNames' | 'contactList'>,
    kind: GlyphKind,
    myStatusLabel: string,
): string | undefined {
    if (kind === 'status') return myStatusLabel;
    if (event.audienceGroupNames?.length) return event.audienceGroupNames.join(', ');
    const first = event.contactList?.[0];
    if (!first) return undefined;
    // A number typed at compose time is stored as its raw digits ("9725…").
    // Say it the way a phone number is written instead.
    return nameOrFormattedPhone(first.name, first.id) || undefined;
}
